/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { APPROVALS_PATH } from '@/modules/approvals/route';

// Hub do legado (router.tsx:709-718): a primeira aba, Internet Banking, que no novo é `/aprovacoes`.
export const Route = createFileRoute('/_app/aprovacoes/gestao-aprovacoes/')({
  beforeLoad: () => {
    throw redirect({ to: APPROVALS_PATH, replace: true });
  },
});
